let config = {
  stagingSsoUrl: 'http://sso-staging.carclub.com.sg/#/login',
  productionSsoUrl: 'http://sso.carclub.com.sg/#/login',
  localSsoUrl: 'http://localhost:8080/#/login',
  prodChangePasswordUrl: 'http://sso.carclub.com.sg/#/change-password',
  stagingChangePasswordUrl: 'http://sso-staging.carclub.com.sg/#/change-password',
  passphrase: 's3cr3t'
}

export default config;
